module.exports = __webpack_public_path__ + "static/img/face-icon.f7bd121.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/face-icon.svg
// module id = pTEs
// module chunks = 0